import { useEffect } from "react";
import { addGlobalContext } from "@getbread/wheat-general";
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { useFeatureFlags } from "@getbread/feature-flag-sdk-react";

declare global {
	interface Window {
		_fs_ready?: () => void;
	}
}

export const GlobalErrorContext = () => {
	const flags = useFeatureFlags();

	useEffect(() => {
		addGlobalContext({ flags });
	}, [flags]);

	return null;
};
